<template>
  <div id="PosBind" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
      <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 ">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">A</span>ñadir tienda</div>
        <div class="col-3 t-r f22 pr3"></div>
      </div>
    </div>
    <div class="h4"></div>
    <div class="col-12 t-c  pt10 pb10">
      <img src="@/assets/store_logo.png" class="r5 w15">
    </div>
    <div class="col-12 t-c pt10 pb10">
      <div class="col-12 mb5"><input type="text" placeholder="APPID" class="bg-color-white h4 b-s-2 r5 pl5 pr5 w30 fw uppercase t-c"></div>
      <div class="col-12 mb5"><input type="text" placeholder="APPSEC" class="bg-color-white h4 b-s-2 r5 pl5 pr5 w30 fw uppercase t-c"></div>
      <div class="col-12 mt20"><input type="button" value="Confirmar" class="b1 h4 pl5 pr5 r5 f14 w30" @click="make_install_password()"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PosBind',
  data () {
    return {
      data_list: [],
      data_status: 0
    }
  },
  created: function () {
    //this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      post_data.user_type = this.$route.query.user_type;
      this.post(this.api_url + 'manage/user_select', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.users;
        }else{
          this.data_list = []
        }
      })
    },
    statusCh(status){
      this.data_status = status;
      this.get_list_data();
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/PosBind.vue